<template>
  <div>
    <Notification
      :message="notification"
      :triggerNotification="showNotification"
      class="w-screen fixed left-0 top-15 z-50"
      @toggle-visibility="showNotification = false"
    />
    <EmailVerificationIllustration class="mx-auto" />
    <h1 class="text-h3 mt-24 md:mt-32">Verify your email to complete your review</h1>
    <p class="text-body mt-32">
      Thank you for leaving a review. In order to ensure safety on our platform a confirmation has been sent to the email address
      you added. Click the verify button in the email sent to confirm your email.
    </p>
    <p class="text-subtitle font-medium mt-16">
      Email verification is for Trust & Safety purposes only. No marketing emails will be sent to you.
    </p>
    <div class="flex flex-col gap-24 mt-32 md:flex-row">
      <Button
        value="Re-send verification email"
        size="medium"
        class="flex-1 md:whitespace-nowrap"
        @click="resendVerificationEmail"
      />
      <Button value="Done" variant="outlined" size="medium" class="flex-1" href="/" />
    </div>
  </div>
</template>

<script lang="ts">
import Notification from '@/components/notification/Notification.vue';
import EmailVerificationIllustration from '@/graphics/illustrations/EmailVerificationIllustration.vue';
import Button from '@/components/button/Button.vue';
import { RESEND_EMAIL_VERIFICATION } from '@/graphql/ratings/mutations';
import { sendSegmentEvent } from '@/lib/segment';

export default {
  name: 'VerifyYourEmail',
  components: { Notification, EmailVerificationIllustration, Button },
  props: {
    segmentPayload: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      notification: '',
      showNotification: false,
    };
  },
  computed: {
    reviewToken(): string {
      return this.$route.params.reviewToken;
    },
  },
  methods: {
    resendVerificationEmail(): any {
      this.$apollo
        .mutate({
          mutation: RESEND_EMAIL_VERIFICATION,
          variables: {
            reviewToken: this.reviewToken,
          },
        })
        .then(() => {
          this.notify("Verification email re-sent. Check your email to verify and don't forget to check your spam folder.");
          this.$emit('resendEmailError', false);
          sendSegmentEvent('Parent Email Verification Sent', this.segmentPayload);
        })
        .catch((e) => {
          this.$emit('resendEmailError', true);
          console.error(e);
        });
    },
    notify(message: string): any {
      this.notification = message;
      this.showNotification = true;
    },
  },
};
</script>
